




















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

const menus = [
  {key: 'home', name: 'Главная'},
  {key: 'breathe', name: 'Дыхание'},
  {key: 'meditate', name: 'Медитация'},
  {key: 'sleep', name: 'Сон'},
  {key: 'music', name: 'Музыка'},
  {key: 'profile', name: 'Профиль'}
]

@Component
export default class MobilePreviewComponent extends Vue {  
  @Prop({default: false, type: Boolean}) showMenu: boolean;
  @Prop({default: 'home', type: String, validator: (value: string) => menus.some(x => x.key == value)}) activeMenu: string;
  menus: {key: string, name: string}[] = menus;
  get currentTime(): string {
    var d = new Date();
    var hs = `0${d.getHours()}`;
    var ms = `0${d.getMinutes()}`;
    var h = hs.substring(hs.length - 2);
    var m = ms.substring(ms.length - 2);
    return `${h}:${m}`;
  }
}
